/* VINYLPAC: libraries that load on first use instead of with the page (10/12).
   window.vpLazy(name) -> Promise, resolved once the library's globals exist. One load per name; a failed load rejects
   and the next call tries again. */
(function () {
  var LIBS = {
    jspdf: ['https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'],
    pdfjs: ['https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js'],
    three128: ['https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js',
               'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/GLTFLoader.js']
  };
  var pending = {};
  function one(src) {
    return new Promise(function (ok, fail) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () { ok(); };
      s.onerror = function () { fail(new Error('could not load ' + src)); };
      document.head.appendChild(s);
    });
  }
  window.vpLazy = function (name) {
    var list = LIBS[name];
    if (!list) return Promise.reject(new Error('vpLazy: unknown ' + name));
    if (!pending[name]) {
      pending[name] = list.reduce(function (p, src) { return p.then(function () { return one(src); }); }, Promise.resolve())
        .catch(function (err) { delete pending[name]; throw err; });
    }
    return pending[name];
  };
})();
